export default "__VITE_ASSET__Cere6chI__"